import React, { useEffect, useCallback } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp"
import { overlays } from "constants/overlays"
import { useSnackbar } from "notistack"
import clsx from "clsx"

const useStyles = makeStyles((theme) => ({
	root: {
		zIndex: 1000,
		position: "absolute",
		[theme.breakpoints.up("sm")]: {
			bottom: theme.spacing(2),
			left: theme.spacing(2),
		},
		[theme.breakpoints.down("xs")]: {
			bottom: theme.spacing(1),
			left: theme.spacing(1),
			right: theme.spacing(1),
			display: "flex",
		},
	},
	buttonOuter: {
		flex: 1,
	},
	button: {
		margin: theme.spacing(0.5),
	},
}))
const NodeLocationNavigator = ({ locationInfo, changeActiveNode, activeOverlay, activeMasterName, activateEntry }) => {
	const classes = useStyles()
	const { enqueueSnackbar } = useSnackbar()
	const { eastNLocId, westNLocId, eastMLocId, westMLocId, mLocId, nLocId } = locationInfo

	const handleKeyUp = useCallback(
		(e) => {
			e.preventDefault()
			if (e.keyCode === 37) {
				changeActiveNode(westMLocId, westNLocId, mLocId, nLocId)
			} else if (e.keyCode === 39) {
				changeActiveNode(eastMLocId, eastNLocId, mLocId, nLocId)
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},
		[eastMLocId, eastNLocId, mLocId, nLocId],
	)

	useEffect(() => {
		window.addEventListener("keyup", handleKeyUp)
		return () => window.removeEventListener("keyup", handleKeyUp)
	}, [handleKeyUp])

	useEffect(() => {
		if (activeMasterName) {
			enqueueSnackbar(`Entering ${activeMasterName} Area`, {
				variant: "warning",
				autoHideDuration: 1000,
				resumeHideDuration: 0,
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeMasterName])

	if (activeOverlay !== overlays.DEVICEIDASSIGNMENT) return null

	return (
		<div className={classes.root}>
			<Button
				variant="contained"
				color="primary"
				size="large"
				className={clsx(classes.buttonOuter, classes.button)}
				disabled={westNLocId === undefined}
				onClick={() => changeActiveNode(westMLocId, westNLocId, mLocId, nLocId)}
			>
				Move West
			</Button>
			<Fab
				color="primary"
				size="small"
				aria-label="select-node-location"
				disabled={mLocId === undefined || nLocId === undefined}
				onClick={() => activateEntry(mLocId, nLocId)}
				className={classes.button}
			>
				<KeyboardArrowUpIcon />
			</Fab>
			<Button
				variant="contained"
				color="primary"
				size="large"
				className={clsx(classes.buttonOuter, classes.button)}
				disabled={eastNLocId === undefined}
				onClick={() => changeActiveNode(eastMLocId, eastNLocId, mLocId, nLocId)}
			>
				Move East
			</Button>
		</div>
	)
}

export default NodeLocationNavigator
